/**
 * JobMatch NG Central Telegram Configuration
 * Official customer-facing Telegram contact & click-to-chat configuration.
 *
 * Safe public values only: NO secrets or TELEGRAM_BOT_TOKEN.
 */

export const TELEGRAM_BOT_USERNAME = 'JobMatchNG_AIAssistant_bot';
export const TELEGRAM_CHAT_URL = `https://t.me/${TELEGRAM_BOT_USERNAME}`;
export const TELEGRAM_ASSISTANT_NAME = 'JobMatch NG Telegram AI';
export const TELEGRAM_ASSISTANT_TITLE = 'Official Telegram Assistant';
